import { Modal, Typography } from "antd";
import "./disconnect-integration-modal.scss";

interface DisconnectIntegrationModalProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  organName?: string;
}

export const DisconnectIntegrationModal = ({
  open,
  onConfirm,
  onCancel,
  organName,
}: DisconnectIntegrationModalProps) => {
  return (
    <Modal
      open={open}
      title="Отключение интеграции"
      onOk={onConfirm}
      onCancel={onCancel}
      okText="Отключить"
      cancelText="Отмена"
      okButtonProps={{
        style: {
          backgroundColor: "rgba(234, 238, 248, 1)",
          color: "rgba(0, 0, 0, 0.85)",
          borderColor: "rgba(234, 238, 248, 1)",
        },
      }}
      width={480}
    >
      <div className="disconnect-integration-modal__content">
        <Typography.Text>
          Вы уверены, что хотите отключить интеграцию
          {organName && ` для "${organName}"`}?
        </Typography.Text>
      </div>
    </Modal>
  );
};

